module.exports = __webpack_public_path__ + "static/media/history.e011d692.png";